import React from 'react';
import { X } from 'lucide-react';

const EMAIL = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export default function EmailChips({ value = [], onChange, placeholder = 'Type an email and press Enter', testId }) {
  const [draft, setDraft] = React.useState('');
  const add = (raw) => {
    const parts = raw.split(/[,;\s]+/).map((s) => s.trim().toLowerCase()).filter(Boolean);
    const good = parts.filter((p) => EMAIL.test(p) && !value.includes(p));
    if (good.length) onChange([...value, ...good]);
    setDraft(parts.filter((p) => !EMAIL.test(p)).join(' '));
  };
  return (
    <div className="flex flex-wrap gap-1.5 p-1.5 rounded-lg border border-slate-200 bg-white min-h-[40px]" data-testid={testId}>
      {value.map((e) => (
        <span key={e} className="inline-flex items-center gap-1 pl-2 pr-1 py-0.5 rounded-full bg-fuchsia-50 text-fuchsia-800 text-xs">
          {e}
          <button type="button" onClick={() => onChange(value.filter((x) => x !== e))} className="p-0.5 rounded-full hover:bg-fuchsia-100"
            data-testid={`${testId}-remove-${e}`} aria-label={`Remove ${e}`}><X className="w-3 h-3" /></button>
        </span>
      ))}
      <input value={draft} onChange={(e) => setDraft(e.target.value)} placeholder={value.length ? '' : placeholder}
        onKeyDown={(e) => { if (['Enter', ',', 'Tab'].includes(e.key) && draft.trim()) { e.preventDefault(); add(draft); } }}
        onBlur={() => draft.trim() && add(draft)}
        className="flex-1 min-w-[160px] text-sm outline-none px-1 bg-transparent" data-testid={`${testId}-input`} />
    </div>
  );
}
